import React from 'react';
import ReactDOM from 'react-dom/client';
import './responsive-utilities.css';
import './index.css';
import App from './App';

if (typeof window !== 'undefined') {
  if (window.ResizeObserver) {
    const OriginalResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          window.requestAnimationFrame(() => callback(entries, observer));
        });
      }
    };
  }

  const suppressResizeObserverError = (event) => {
    const reason = event?.reason;
    const message =
      event?.message ||
      reason?.message ||
      (typeof reason === 'string' ? reason : '') ||
      '';

    if (
      message.includes('ResizeObserver loop completed with undelivered notifications') ||
      message.includes('ResizeObserver loop limit exceeded')
    ) {
      event.preventDefault?.();
      event.stopPropagation?.();
      event.stopImmediatePropagation();
    }
  };

  window.addEventListener('error', suppressResizeObserverError, true);
  window.addEventListener('unhandledrejection', suppressResizeObserverError, true);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
